import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  linkBrandName: {
    color: '#8D1A3F',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
}));
